module.exports = __webpack_public_path__ + "img/lp_2@3x.fc419428.png";